module.exports = __webpack_public_path__ + "static/media/copy.f631883d.svg";